module.exports = __webpack_public_path__ + "static/img/present_1.e08c149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/present_1.png
// module id = Fb1X
// module chunks = 1